<template>
  <rect width="62" height="24" rx="3" fill="#323232" />
  <rect x="10" y="9.5" width="32" height="5" rx="2.5" fill="#7C7C7C" />
  <path
    d="M51.4624 13.7903C51.207 14.0699 50.793 14.0699 50.5376 13.7903L48.1928 11.2225C47.7809 10.7713 48.0726 10 48.6552 10L53.3448 10C53.9274 10 54.2191 10.7713 53.8072 11.2225L51.4624 13.7903Z"
    fill="#7C7C7C" />
</template>
